import React, { useState } from "react";
import PaywallMarkup from "web/react/components/paywall-markup/paywall-markup";
import WebToAppCampaignModal from "web/react/components/web-to-app-campaign-modal/web-to-app-campaign-modal";
import useWebToAppCampaign, {
    CampaignOptions,
} from "web/react/hooks/use-web-to-app-campaign/use-web-to-app-campaign";

interface WebToAppCampaignProps {
    children: React.ReactNode;
    options: CampaignOptions;
    beforeOnClick?: () => void;
    onCampaignNotActive: (event) => void;
    onContinueClick?: (event) => void;
    analyticsEventLabel: string;
    id?: number | string;
    productImageUrl?: string;
    continueOptionHref?: string;
}

export default function WebToAppCampaign({
    children,
    options,
    beforeOnClick,
    onCampaignNotActive,
    onContinueClick,
    analyticsEventLabel,
    productImageUrl,
    id = "",
    continueOptionHref = "",
}: WebToAppCampaignProps): JSX.Element {
    const paywalledClassName = analyticsEventLabel;
    const [hasBeenBlocked, setHasBeenBlocked] = useState<boolean>(false);
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const {
        campaignDetails,
        onLoad,
        onClick: onCtaClick,
        fetchCampaign,
    } = useWebToAppCampaign(
        "block_modal",
        {
            hasBeenBlocked,
            ...options,
        },
        false
    );

    function openModal(): void {
        setModalIsOpen(true);
    }

    function closeModal(): void {
        setModalIsOpen(false);
    }

    function onClick(event): void {
        // we must persist the event so it can be used after the handler has run
        event.preventDefault();
        event.persist?.();

        // run anything, regardless of the campaign decision - useful for sending
        // analytics data related to the wrapped component
        beforeOnClick?.();
        fetchCampaign().then((campaignDetailsData) => {
            if (campaignDetailsData) {
                openModal();
            } else {
                onCampaignNotActive(event);
            }
        });
    }

    if (campaignDetails && !hasBeenBlocked) {
        setHasBeenBlocked(true);
        onLoad();
    }

    return (
        <>
            <span className={paywalledClassName} onClick={onClick}>
                {children}
            </span>
            <WebToAppCampaignModal
                id={id}
                isOpen={modalIsOpen}
                onClose={closeModal}
                campaignDetails={campaignDetails}
                continueOptionHref={continueOptionHref}
                onContinueClick={onContinueClick}
                onCtaClick={onCtaClick}
                analyticsEventLabel={analyticsEventLabel}
                productImageUrl={productImageUrl}
            />
            <PaywallMarkup cssSelector={paywalledClassName} />
        </>
    );
}
